import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { Button, Grid, Menu, MenuItem, Paper } from "@material-ui/core"
import Box from "@material-ui/core/Box"
import { STableLoader } from "../../../shared_elements/loaders"
import { TableListComp, PageLoader, FilterUIComp, EmptyCollection, AssetAddDropdown, AccessDenied, } from "../../../shared_elements"
import { AssetList, AssetListTab, AddAircraft, AddEngine } from "../components"
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, checkApiStatus} from "../../../utils"
import { getAircraftTypesAc,getEngineFamilyAc, getEngineTypesAc, getLesseeListAc, getOperatorListAc, getRegionListAc, getPlatformConstantsAc, getPortfolioListAc, getAircraftMntProgramAc, getLeaseStatus, getSubStatus, } from "../../../shared_elements/actionCreators"
import { assetListHd, maintenanceFilterOps, engineHeader, smbcFilters } from "../"
import { getAssetListApi, exportAssetListApi, addNewAssetApi, } from "../apiServices"
import { trackActivity } from "../../../utils/mixpanel"
import DownloadXlsx from "../../../shared_elements/components/DownloadXlsx"
import DownloadPdf from "../../../shared_elements/components/DownloadPdf"
import SaveAltIcon from "@material-ui/icons/SaveAlt"
import config from '../../../config';
import { halcyonInstance,smbcInstance } from "../../../shared_elements/components"
import DeploymentMessage from "../../../shared_elements/components/DeploymentMessage"
import FilterComponent from '../../../shared_elements/components/filter_component';
class AssetListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      skeletonLoader: false,
      pageLoader: false,
      addAssetType: "",
      addAssetModal: false,
      licenseModal: false,
      licenseModalMessage: "",
      tabIndex: smbcInstance || halcyonInstance ? 2 : 0,
      sort: "",
      sort_by: "",
      assets: { list: [], pagination: {}, asset_count: {}, },
      filter: {},
      applyingFilter: {},
      ownersList: [],
      menuAnchorEl: null,
      engineModel:{}
    }
    this.getAssetListApi = getAssetListApi.bind(this)
    this.exportAssetListApi = exportAssetListApi.bind(this)
    this.addNewAssetApi = addNewAssetApi.bind(this)
  }

  componentDidMount() {
    const savedFilter = localStorage.getItem("savedFilterValue");
    const savedSorting = localStorage.getItem("sortField");
    const parsedFilter = savedFilter ? JSON.parse(savedFilter) : null;
    const parsedSorting = savedSorting ? JSON.parse(savedSorting) :null;
    if ( savedFilter &&  savedSorting) {
      this.setState({ filter: parsedFilter,sort: parsedSorting?.sort,sort_by: parsedSorting?.sort_by }, () => { this.getAssetListApi({ ...this.state.filter,...parsedSorting, per_page: 50 }, "skeletonLoader"); });
    }else if(parsedFilter) {
      this.setState({ filter: parsedFilter }, () => { this.getAssetListApi({ ...this.state.filter, per_page: 200 }, "skeletonLoader"); });
    }else if(savedSorting) {
      this.setState({ sort: parsedSorting?.sort,sort_by: parsedSorting?.sort_by }, () => { this.getAssetListApi({ ...parsedSorting, per_page: 50 }, "skeletonLoader"); });
    }else{
      this.getAssetListApi({ per_page: 200 }, "skeletonLoader")
    }
    this.props.getPlatformConstants()
    this.props.getLesseeList()
    this.props.getOperatorList()
    this.props.getRegionList()
    this.props.getPortfolioList()
    this.props.getEngineTypes()
    this.props.getEngineFamily()
    this.props.getAircraftTypes()
    this.props.getLeaseStatus()
    this.props.getSubStatus()
    trackActivity('CAMO', {
      event_type: 'Page Visited',
      page_title: 'Asset Listing',
    })
  }
  addAircraftAsset = (props, url, payload) => {
    this.addNewAssetApi(props, url, payload).then((response) => {
      this.setState({ formSubmitLoader: false })
      if (checkApiStatus(response)) {
        this.setState({ addAssetModal: false })
        this.getAssetListApi({ per_page: 200 }, "skeletonLoader")
        this.props.enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
        trackActivity('CAMO', {
          event_type: 'Add Aircraft Sucessful',
          page_title: 'Asset Listing',
        })
      } else if (response && response.data && response.data.status === "FAIL") {
        this.props.enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
      }
    })
  }
  changeTabs = (event, newValue) => {
    this.setState((prevState) => ({
      ...prevState,
      tabIndex: newValue,
    }))
    this.getAssetListApi(this.props, { asset_type: newValue }, "pageLoader")
  }

  onTabChange = (e, newValue) => {
    const { assets } = this.state
    this.setState({ tabIndex: newValue, applyingFilter: {}, filter: {} })
    if (newValue === 0) {
      this.getAssetListApi({ per_page:200 }, "pageLoader")
    } else {
      this.getAssetListApi({ asset_type: newValue, per_page:200 }, "pageLoader")
    }
  }

  createSortHandler = (sortField, clear) => {
    const { sort, sort_by, filter, tabIndex, assets } = this.state
    if (clear) {
      localStorage.removeItem("sortField")
      this.getAssetListApi({ ...filter, per_page:200, asset_type: tabIndex, }, "pageLoader")
      this.setState({sort: '', sort_by: ''})
    } else {
      if (sortField === "current_registration_number") {
        sortField = "registration"
      } else if (sortField === "location") {
        sortField = "country"
      } else if (sortField === "lessor") {
        sortField = "lessor_name"
      }
      this.setState({ sort: sortField, sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "asc", })
      if (sortField === sort) {
        if (sort_by === "asc") {
           localStorage.setItem("sortField", JSON.stringify({ sort: sortField, sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "asc", }));
          this.getAssetListApi({ ...filter, sort: sortField, sort_by: "desc", per_page: 200, asset_type: tabIndex, }, "pageLoader")
        } else {
          localStorage.setItem("sortField", JSON.stringify({ sort: sortField, sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "asc", }));
          this.getAssetListApi({ ...filter, sort: sortField, sort_by: "asc", per_page: 200, asset_type: tabIndex, }, "pageLoader")
        }
      } else {
        localStorage.setItem("sortField", JSON.stringify({ sort: sortField, sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "asc", }));
        this.getAssetListApi({ ...filter, sort: sortField, sort_by: "asc", per_page: 200, asset_type: tabIndex, }, "pageLoader")
      }
    }
  }
  

  toggleAssetType = (addAssetType) => {
    this.setState({ addAssetType: addAssetType, addAssetModal: true })
  }

  onHandleClick = (event) => {
    this.setState({
      menuAnchorEl: event.currentTarget,
    })
  }
  onHandleClose = () => {
    this.setState({
      menuAnchorEl: null,
    })
  }

  render() {
    const openMenu = Boolean(this.state.menuAnchorEl)
    const { engineModel,skeletonLoader, pageLoader, addAssetType, addAssetModal, assets, tabIndex, filter, applyingFilter, sort, sort_by, ownersList, licenseModal, licenseModalMessage } = this.state
    const { portfolios, regions, aircraftTypes,engineFamily, engineTypes, pltConstants, lessees, operators, aircraftMntGrp, leaseStatus, subStatus } = this.props
     
    let filterOptions = maintenanceFilterOps

    if (tabIndex === 0 || tabIndex === 1) {
      filterOptions = {
        ...filterOptions,
        aircraft_type: {
          ...filterOptions.aircraft_type,
          options: aircraftTypes,
        },
      }
      if (tabIndex === 1) {
        delete filterOptions.engine_type
      }
    }
    if (tabIndex === 0 || tabIndex === 2) {
      filterOptions = {
        ...filterOptions,
        engine_type: {
          ...filterOptions.engine_type,
          options: engineTypes,
        },
      }
      if (tabIndex === 2) {
        delete filterOptions.aircraft_type
      }
      if (tabIndex === 2) {
        delete filterOptions.registration
      }
    }
    filterOptions = {
      ...filterOptions,
      lessee: {
        ...filterOptions.lessee,
        options: lessees,
      },
      operator: {
        ...filterOptions.operator,
        options: operators
      },
    }
    const assetFilterObj = Object.assign({}, filter)
    delete assetFilterObj['asset_type']

    let smbcfilterOptions = Object.assign({}, smbcFilters)
    smbcfilterOptions = {
      ...smbcfilterOptions,
       engine_family: {
        ...smbcfilterOptions.engine_family,
        options: engineFamily || [],
      },
      engine_type: {
        ...smbcfilterOptions.engine_type,
        options: engineTypes || [],
      },
      operator: {
        ...smbcfilterOptions.operator,
        options: operators || []
      },
      lessee: {
        ...smbcfilterOptions.lessee,
        options: lessees || []
      },
    }
   
    const savedSorting = localStorage.getItem("sortField");
    const parsedSorting = savedSorting ? JSON.parse(localStorage.getItem('sortField')) : {};
    return (
      <section className="asset-listing-section">
        <DeploymentMessage />
        <div style={{ width: "100%" }}>
          <Box display="flex" style={{ alignItems: "center" }}>
            <Box flexGrow={1}>
              <h3 className="asset-list-heading">Assets</h3>
            </Box>
            <Box>
              {assets.list.length ? (
                <div className="d-flex">
                  {/* {permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "C", }) ? ( */}
                    <div className="asset-export">
                      <Button
                        id="basic-button"
                        aria-controls={openMenu ? "basic-menu" : ""}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : ""}
                        onClick={this.onHandleClick}
                        startIcon={<SaveAltIcon />}
                      >
                        EXPORT
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={this.state.menuAnchorEl}
                        open={openMenu}
                        onClose={this.onHandleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem className="export-list">
                          <DownloadPdf
                            title="Export PDF"
                            files={{ title: "PDF", extension: "pdf", key: "" }}
                            exportReportFn={(file) => this.exportAssetListApi({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, ...assetFilterObj } }, "pageLoader")}
                          />
                        </MenuItem>
                        <MenuItem className="export-list">
                          <DownloadXlsx
                            title="Export Exel"
                            files={{ title: "EXCEL", extension: "xlsx", key: "" }}
                            exportReportFn={(file) => this.exportAssetListApi({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, ...assetFilterObj } }, "pageLoader")}
                          />
                        </MenuItem>

                      </Menu>
                    </div>
                  <div>
                    <span className="add-asset-cta">
                      <AssetAddDropdown
                        toggleAssetType={this.toggleAssetType}
                      />
                    </span>
                  </div>
                </div>
              ) : null}
            </Box>
          </Box>
        </div>
        {/* {permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "R", }) ? ( */}
          <Fragment>
            {skeletonLoader ? (
              <STableLoader count={7} />
            ) : (
              <Fragment>
                <AssetListTab
                  item={assets}
                  onTabChange={this.onTabChange}
                  tabIndex={tabIndex}
                />
                <div>
                  <Paper className="plt-filter-comp d-flex align-items-center">
                    <FilterComponent
                      savedFilterValue={true}
                      filter={assetFilterObj}
                      filterMenu={smbcInstance ? smbcfilterOptions : filterOptions}
                      // getResponseBack={(applyFilter) => this.getAssetListApi({ ...applyFilter, sort:parsedSorting?.sort,sort_by: parsedSorting?.sort_by ,asset_type: this.state.tabIndex, per_page: smbcInstance ? 200 : assets.pagination.per_page }, "pageLoader")}
                      getResponseBack={(applyFilter) => this.getAssetListApi({ ...applyFilter, sort:parsedSorting?.sort,sort_by: parsedSorting?.sort_by ,asset_type: this.state.tabIndex, per_page: 200 }, "pageLoader")}
                    />
                  </Paper>
                  <TableListComp
                    // heads={engineHeader}
                    heads={tabIndex === 2 ? engineHeader : assetListHd}
                    sort={sort}
                    sort_by={sort_by}
                    tabIndex={tabIndex}
                    data={assets.list.map((item, index) => (
                      <AssetList
                        key={index}
                        item={item}
                        index={index}
                        props={this.props}
                        tabIndex={tabIndex}
                      />
                    ))}
                    createSortHandler={this.createSortHandler}
                    pagination={assets.pagination}
                    onChangePage={(event, newPage) => this.getAssetListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: assets.pagination.per_page, page: newPage + 1, }), filterOptions), }, "pageLoader")}
                    onChangeRowsPerPage={(event) => this.getAssetListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: event.target.value, }), filterOptions), }, "pageLoader")}
                    noRecord={assets.list.length ? null : (<EmptyCollection title="No Records Found" />)}
                  />
                </div>
              </Fragment>
            )}
          </Fragment>
        {addAssetType === "Aircraft" ? (
          <AddAircraft
            fetchMntGrops={(aircraftId) =>
              this.props.getAircraftMntProgram(aircraftId)
            }
            addAircraftAsset={this.addAircraftAsset}
            aircraftMntGrp={aircraftMntGrp}
            leaseStatus={leaseStatus}
            subStatus={subStatus}
            portfolios={portfolios}
            ownersList={ownersList}
            lessees={lessees}
            operators={operators}
            pltConstants={pltConstants}
            aircraftTypes={aircraftTypes}
            addAssetType={addAssetType}
            addAssetModal={addAssetModal}
            toggleAssetType={() => this.setState({ addAssetType: "", addAssetModal: false })}
            toggleLicenseModalFn={(modal, message) => this.setState({ licenseModal: modal, licenseModalMessage: message, addAssetModal: false, })}
          />
        ) : null}
        {addAssetType === "Engine" && addAssetModal ? (
          <AddEngine
            portfolios={portfolios}
            ownersList={ownersList}
            regions={regions}
            lessees={lessees}
            operators={operators}
            pltConstants={pltConstants}
            engineTypes={engineTypes}
            addAssetType={addAssetType}
            addAssetModal={addAssetModal}
            toggleAssetType={() => this.setState({ addAssetType: "", addAssetModal: false })}
            toggleLicenseModalFn={(modal, message) => this.setState({ licenseModal: modal, licenseModalMessage: message, addAssetModal: false, })
            }
          />
        ) : null}
        {pageLoader ? <PageLoader /> : null}
      </section>
    )
  }
}
const mapStateToProps = (state) => ({
  aircraftTypes: state.shareReducer.aircraftTypes,
  engineFamily: state.shareReducer.engineFamily,
  engineTypes: state.shareReducer.engineTypes,
  lessees: state.shareReducer.lessees,
  operators: state.shareReducer.operators,
  regions: state.shareReducer.regions,
  portfolios: state.shareReducer.portfolios,
  pltConstants: state.shareReducer.pltConstants,
  aircraftMntGrp: state.shareReducer.aircraftMntGrp,
  leaseStatus: state.shareReducer.leaseStatus,
  subStatus: state.shareReducer.subStatus,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getAircraftTypes: (props, query) => dispatch(getAircraftTypesAc(props, query)),
    getRegionList: () => dispatch(getRegionListAc()),
    getEngineFamily: () => dispatch(getEngineFamilyAc({active:true})),
    getEngineTypes: () => dispatch(getEngineTypesAc({distinct:1})),
    getLesseeList: () => dispatch(getLesseeListAc('',{distinct:1})),
    getOperatorList: () => dispatch(getOperatorListAc('',{distinct:1})),
    getPortfolioList: () => dispatch(getPortfolioListAc()),
    getAircraftMntProgram: (aircraftId) => dispatch(getAircraftMntProgramAc(aircraftId)),
    getPlatformConstants: () => dispatch(getPlatformConstantsAc({ constant_types: ["asset_status", "credit_classification", "engine_position", "lg_position",], })),
    getLeaseStatus: () => dispatch(getLeaseStatus({ constant_types: ["lease_status"] })),
    getSubStatus: () => dispatch(getSubStatus({ constant_types: ["asset_sub_status"] })),
  }
}
export default withSnackbar(
  connect(mapStateToProps, mapDispatchToProps)(AssetListing)
)
